<template>
  <div class="segment_news">
    <div class="content-wrapper">
      
      <segment-single-news v-for="segment_news in segment_news_data" :key="segment_news.id" :segment_news="segment_news"></segment-single-news>

    </div>
  </div>
</template>

<script>
  import segmentNewsJsonData from "@/generated/segment_news.json";
  import segmentSingleNews from '@/components/segment_single_news';

  export default {
    data() {
      return {
        segment_news_data: {}
      };
    },
    mounted() {
      let cmp = this;
      cmp.segment_news_data = segmentNewsJsonData;
    },
    components: {
      segmentSingleNews
    }
  };
</script>

<style lang="scss">
  .copy__itself strong {
    font-weight: 600;
  }

  .copy__itself strong a {
        color: #00A790;
        text-decoration: none;

        &:hover {
            color: darken(#00A790, 5%);
        }
    }
</style>

<style lang="scss" scoped>
  .segment_news {
    .content-wrapper {
      display: flex;
      flex-direction: column;
      text-align: center;

      @media only screen and (max-width : 991px) {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }
  }
</style>